import React from 'react';

interface Props {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

const My5LightLogo: React.FC<Props> = ({ width = 30, height = 35, color = 'white', className }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox="0 0 21 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_5885_29040)">
            <path
                d="M6.78887 8.5798H0.568968L3.18132 0.666194C3.33204 0.214643 3.56025 0.000976562 4.00442 0.000976562H9.62586L6.78887 8.5798Z"
                fill={color}
            />
            <path
                d="M10.5716 0.000976562H17.9095C18.3602 0.000976562 18.7539 0.270444 18.7411 0.807719C18.7411 3.44649 18.7411 3.54479 18.7411 4.94828C18.7411 5.41904 18.3885 5.73773 17.9267 5.73773H8.67204L10.5716 0.000976562Z"
                fill={color}
            />
            <path
                d="M0.557652 9.47461L2.88074 14.2297C3.07597 14.6818 3.44726 15.185 4.23192 15.185H10.3089C16.626 15.185 19.6943 21.1292 19.2402 24.7375C19.2402 24.7375 20.5825 22.6451 20.5825 19.6077C20.5825 14.0894 15.8377 9.47461 10.4666 9.47461H0.557652Z"
                fill={color}
            />
            <path
                d="M10.782 30.0002V23.6318C12.9286 23.3318 14.2322 21.6464 14.2322 19.7054C14.2322 18.2015 13.418 17.0601 12.2383 16.3456C15.2184 16.9571 18.2964 19.9788 18.2964 23.5577C18.2964 26.4927 16.2112 29.6521 10.782 30.0002Z"
                fill={color}
            />
            <path
                d="M9.78368 23.6327V30.001C3.50508 29.6127 0 24.4714 0 19.8137C0 19.2715 0.327776 18.9222 0.799889 18.9222H5.52728C5.98466 18.9222 6.27715 19.2737 6.29881 19.7203C6.33252 21.4781 7.43128 23.1851 9.78368 23.6327Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_29040">
                <rect width="20.5469" height="30" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default My5LightLogo;
